import React, { useState } from "react";
import moment from "moment";
import Modal from "react-modal";
import Swal from "sweetalert2";
import ModalCreateEvent from "./ModalCreateEvent";
import { getFirestore, doc, deleteDoc } from "firebase/firestore";

const VistaAño = ({
  events,
  currentDate,
  onSave,
  filters,
  handleAddCategory,
  refreshData,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedDayEvents, setSelectedDayEvents] = useState([]);
  const [selectedDay, setSelectedDay] = useState("");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [eventToEdit, setEventToEdit] = useState(null);

  const handleEditClick = (event) => {
    setEventToEdit({
      ...event,
      start: event.start ? moment(event.start).format("YYYY-MM-DDTHH:mm") : "",
    });
    setEditModalOpen(true);
    // Cerramos el modal del día para que no se encime con el modal de edición
    setModalOpen(false);
  };

  const handleDeleteClick = async (event) => {
    const firestore = getFirestore();
    const confirm = await Swal.fire({
      title: "¿Eliminar evento?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });
    if (confirm.isConfirmed) {
      try {
        if (event.resource === "evento") {
          await deleteDoc(
            doc(firestore, "eventos", event.id.replace("evento-", ""))
          );
        } else if (event.resource === "tarea") {
          await deleteDoc(
            doc(firestore, "tareaCalendario", event.id.replace("tarea-", ""))
          );
        }
        Swal.fire(
          "Eliminado",
          "El evento ha sido eliminado con éxito.",
          "success"
        );
        closeModal();
        if (refreshData) refreshData();
      } catch (error) {
        console.error("Error al eliminar:", error);
        Swal.fire("Error", "No se pudo eliminar el evento.", "error");
      }
    }
  };

  const months = Array.from({ length: 12 }, (_, i) =>
    currentDate.clone().startOf("year").month(i)
  );

  const daysOfWeek = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];

  const handlePointClick = (day, dayEvents) => {
    setSelectedDay(day.format("DD MMMM YYYY"));
    setSelectedDayEvents(dayEvents);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedDayEvents([]);
    setSelectedDay("");
  };

  return (
    <div className="p-2">
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold text-gray-800">
          {currentDate.format("YYYY")}
        </h2>
      </div>

      <div className="grid grid-cols-3 gap-6">
        {months.map((month) => {
          const daysInMonth = Array.from(
            { length: month.daysInMonth() },
            (_, day) => day + 1
          );

          const monthEvents = events.filter((event) =>
            moment(event.start).isSame(month, "month")
          );

          return (
            <div
              key={month.format("MM")}
              className="border rounded-sm bg-white shadow-md"
            >
              <div className="p-4 text-center border-b">
                <h3 className="text-lg font-semibold text-gray-800">
                  {month.format("MMMM")}
                </h3>
              </div>

              <div className="grid grid-cols-7 text-center text-xs font-medium text-gray-500 p-2">
                {daysOfWeek.map((day, index) => (
                  <div key={index}>{day}</div>
                ))}
              </div>

              <div className="grid grid-cols-7 text-center text-sm p-2 gap-1">
                {Array.from({
                  length: (month.startOf("month").day() + 6) % 7,
                }).map((_, i) => (
                  <div key={`empty-${i}`} />
                ))}

                {daysInMonth.map((day) => {
                  const dayDate = month.clone().date(day);
                  const isToday = moment().isSame(dayDate, "day");

                  const dayEvents = monthEvents.filter((event) =>
                    moment(event.start).isSame(dayDate, "day")
                  );

                  // Filtramos por recurso:
                  const cotizaciones = dayEvents.filter(
                    (event) => event.resource === "cotizacion"
                  );
                  const eventos = dayEvents.filter(
                    (event) => event.resource === "evento"
                  );
                  const festivos = dayEvents.filter(
                    (event) => event.resource === "festivo"
                  );
                  const tareas = dayEvents.filter(
                    (event) => event.resource === "tarea"
                  );

                  return (
                    <div
                      key={day}
                      className={`p-1 rounded-sm relative cursor-pointer ${
                        isToday
                          ? "bg-blue-300 text-white font-bold"
                          : "hover:bg-gray-100 text-gray-700"
                      }`}
                      onClick={() => handlePointClick(dayDate, dayEvents)}
                    >
                      {day}
                      <div className="flex justify-center mt-1 gap-1">
                        {cotizaciones.length > 0 && (
                          <span className="w-2 h-2 rounded-full bg-blue-500"></span>
                        )}
                        {eventos.length > 0 && (
                          <span className="w-2 h-2 rounded-full bg-green-500"></span>
                        )}
                        {festivos.length > 0 && (
                          <span className="w-2 h-2 rounded-full bg-red-500"></span>
                        )}
                        {tareas.length > 0 &&
                          tareas.map((tarea, i) => (
                            <span
                              key={i}
                              className="w-2 h-2 rounded-full"
                              style={{ backgroundColor: tarea.color }}
                            ></span>
                          ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>

      {/* Modal para mostrar los eventos del día */}
      <Modal
        isOpen={modalOpen}
        onRequestClose={closeModal}
        contentLabel="Eventos del Día"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 101,
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            maxWidth: "400px",
            width: "90%",
            borderRadius: "4px",
            padding: "20px",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.3)",
            border: "none",
            backgroundColor: "#fff",
            fontFamily: "'Roboto', sans-serif",
          },
        }}
      >
        <div>
          <h3 className="text-lg font-bold text-center mb-4 text-gray-800">
            {selectedDay}
          </h3>
          <div style={{ textAlign: "center" }}>
            {selectedDayEvents.map((event) => (
              <div
                key={event.id}
                style={{
                  background: event.color,
                  padding: "0.5rem",
                  borderRadius: "4px",
                  marginBottom: "10px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <i
                    className={`bi ${
                      event.resource === "cotizacion"
                        ? "bi-file-earmark-text"
                        : event.resource === "evento"
                        ? "bi-calendar-event"
                        : event.resource === "festivo"
                        ? "bi-star"
                        : "bi-rocket-takeoff"
                    } text-xl`}
                    style={{ alignSelf: "flex-start" }}
                  />
                  <span
                    style={{
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      overflowWrap: "break-word",
                      maxWidth: "90%",
                      display: "block",
                      textAlign: "justify",
                    }}
                  >
                    {event.title}
                  </span>
                </div>

                {/* Botones alineados a la derecha y al final */}
                {(event.resource === "evento" ||
                  event.resource === "tarea") && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "10px",
                    }}
                  >
                    <button
                      onClick={() => handleEditClick(event)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        padding: "5px 10px",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#fff",
                        backgroundColor: "#007bff",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        minWidth: "80px",
                        justifyContent: "center",
                        marginRight: "8px",
                      }}
                    >
                      <i
                        className="bi bi-pencil-square"
                        style={{ fontSize: "14px" }}
                      ></i>
                      Editar
                    </button>
                    <button
                      onClick={() => handleDeleteClick(event)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        padding: "5px 10px",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#fff",
                        backgroundColor: "#DC2626",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        minWidth: "80px",
                        justifyContent: "center",
                      }}
                    >
                      <i
                        className="bi bi-trash"
                        style={{ fontSize: "14px" }}
                      ></i>
                      Eliminar
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>

          <button
            onClick={closeModal}
            className="modal-close"
            aria-label="Cerrar modal"
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>
      </Modal>

      <ModalCreateEvent
        isOpen={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        initialData={eventToEdit}
        onSave={onSave} // O la función que uses para guardar
        categories={filters} // O la prop correspondiente a tus categorías
        onAddCategory={handleAddCategory} // Si tienes esta función
      />
    </div>
  );
};

export default VistaAño;
